import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarker, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const ContactDetails = () => {
    return (
        <Container>
            <div class="column-right">
                <h2 id="input-head1">Our contact details</h2>
                <div class="address">
                    <div className="iconDiv">

                        <FontAwesomeIcon
                            icon={faMapMarker}
                            className="icond"
                        />
                    </div>
                    <div class="address__text">
                        <h3>Address</h3>
                        <p>Mumbai, Maharashtra</p>
                    </div>
                </div>
                <div class="address">
                    <div className="iconDiv">
                        <FontAwesomeIcon
                            icon={faPhone}
                            className="icond"
                        />
                    </div>
                    <div class="address__text">
                        <h3>Phone</h3>
                        <p>0826 847 465</p>
                    </div>
                </div>
                <div class="address">
                    <div className="iconDiv">

                        <FontAwesomeIcon
                            icon={faEnvelope}
                            className="icond"
                        />
                    </div>
                    <div class="address__text">
                        <h3>Email</h3>
                        <p>info@websolutions.com</p>
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default ContactDetails


const Container = styled.div`
    color: black !important;
    height: 60vh;
    padding: 2rem 2rem;
    h2{
        color: #000219;
        font-size: 1.5rem;
        text-transform: capitalize;
        font-weight: 800;
        padding: 1rem;
    }
    p{
        color: #000219;
    }
    h3{
        color: #000219;
    }
    .address {
        display: flex;
        color: black;
        padding: 0.5rem 0rem;
    }

    .iconDiv{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
    }

    .icond{
        font-size: 3rem;
        margin-right: 1rem;
        color: #e21f36;
    }
    .address__text{
        display: flex;
        flex-direction: column;
        /* align-items: center; */
        justify-content: center;
    }
`